var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContact = function SvgContact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.2 964.1c0 79.1 64.1 143.2 143.1 143.3l206.1.2H984c72.9 0 132-59.1 132-132V274.3c0-72.9-59.1-132-132-132H217.2c-72.9 0-132 59.1-132 132zM600 360c74.4 0 134.4 60 134.4 134.4s-60 134.4-134.4 134.4-134.4-60-134.4-134.4S525.6 360 600 360m0 312c147.6 0 267.6 120 267.6 267.6H332.4C332.4 792 452.4 672 600 672"
  })));
};
export default SvgContact;